import axios from "axios";
import _ from "lodash";
import constants from "@/config/constants";

function initialState() {
    return {   
        all: [],    
        trivias: null,
        triviaitems: {
            event_id: null,
            title: null,
            is_open: false,
            status: true,
            is_deleted: false,
            time_limit: 30,
            questions_detail: [],
        },   
        newTrivia: false,
        isTriviaNew: false,
        loading: false
    }
}

const getters = {      
    all: state => state.all,
    trivias: state => state.trivias,
    triviaitems: state => state.triviaitems,
    newTrivia: state => state.newTrivia,
    isTriviaNew: state => state.isTriviaNew,
    loading: state => state.loading
}

const actions = {
    setTriviaItemsData({ commit, state }, value) {
        commit('setTriviaItemsData', value)
    },

    fetchTriviaData({ commit, state }, event_id) {     
        commit('setLoading', true)

        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };

        axios.get(`${constants.API_URL}/api/trivia/event-id/${event_id}`, {headers: headers})
            .then(response => {
                if(response.data.data && response.data.data.length > 0) {
                    commit('setTriviaItems', response.data.data[0]); 
                    commit('setIsTriviaNew', false);
                    commit('setNewTrivia', false);
                } else {
                    commit('setNewTrivia', true);
                    commit('setIsTriviaNew', true);
                }
            })            
            .finally(() => {
                commit('setLoading', false)
            })
    },

    storeTriviaData({ commit, state, dispatch }, event_id) {
        commit('setLoading', true)         

        const params = _.cloneDeep(state.triviaitems);
        params.event_id = event_id;
        delete params._id;
        delete params.__v;
        delete params.createdAt;
        delete params.updatedAt;

        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
   
        return axios.post(constants.API_URL + '/api/trivia', params, {headers: headers})
            .then(response => {
                commit('setTriviaItems', response.data.data);
                commit('setNewTrivia', false);
                commit('setIsTriviaNew', false);
                return response;
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },

    async updateTriviaData({ commit, state, dispatch }, data) {  
        commit('setLoading', true)      
        let params = _.cloneDeep(state.triviaitems);
        
        delete params._id;
        delete params.__v;
        delete params.createdAt;
        delete params.updatedAt;
        delete params.questions_detail;

        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };         
        
        return axios.patch(constants.API_URL + '/api/trivia/' + data.trivia_id, params, {headers: headers})       
            .then((response) => {
                commit('setTriviaItems', response.data.data);
                return response;
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },

    destroyTriviaData({ commit, state }, id) {
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };        

        return axios.delete(constants.API_URL + '/api/trivia/' + id, {headers: headers})
            .then(response => {
                commit('resetState');
                commit('setNewTrivia', true);
                commit('setIsTriviaNew', true);
                return response;
            })
            .catch(error => {
                const message = error.response?.data?.message || error.message;
                commit('setError', message);
                console.log(error);
                throw error;
            })
    },

    resetState({ commit }) {
        commit('resetState')
    },
    
    setIs_open({ commit }, value) {
        commit('setIs_open', value)
    },
    
    setTriviaTitle({ commit }, value) {
        commit('setTriviaTitle', value)
    },
    
    setTimeLimit({ commit }, value) {
        commit('setTimeLimit', value)
    },
    
    setNewTrivia({ commit }, value) {
        commit('setNewTrivia', value)
    },
    
    setIsTriviaNew({ commit }, value) {
        commit('setIsTriviaNew', value)
    },
    
    setStatus({ commit }, value) {
        commit('setStatus', value)
    },
    
    setIsDeleted({ commit }, value) {
        commit('setIsDeleted', value)
    }
}

const mutations = {
    setTriviaItemsData(state, value) {        
        state.triviaitems = value
    },
    
    setIs_open(state, value) {        
        state.triviaitems.is_open = value
    },
    
    setTriviaTitle(state, value) {  
        state.triviaitems.title = value
    },
    
    setTimeLimit(state, value) {
        state.triviaitems.time_limit = value
    },
    
    setStatus(state, value) {
        state.triviaitems.status = value
    },
    
    setIsDeleted(state, value) {
        state.triviaitems.is_deleted = value
    },
    
    setNewTrivia(state, value) {        
        state.newTrivia = value
    },
    
    setIsTriviaNew(state, value) {
        state.isTriviaNew = value
    },
    
    setLoading(state, loading) {
        state.loading = loading
    },
    
    resetState(state) {
        Object.assign(state, initialState())
    },
    
    setTriviaItems(state, items) {
        state.triviaitems = items
        state.trivias = items
    },
    
    setAll(state, items) {
        state.all = items
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}